import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    CircularProgress,
    Alert,
} from "@mui/material";
import { Warning } from "@mui/icons-material";

const ArchiveConfirmDialog = ({ open, onClose, onUpdate, confirming }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle variant="h4">Επιβεβαίωση Αρχειοθέτησης</DialogTitle>
            <DialogContent dividers>
                <Typography sx={{ mb: 1 }}>
                    Είστε σίγουρος ότι θέλετε να προχωρήσετε στην αρχειοθέτηση;
                </Typography>
                <Alert icon={<Warning />} severity="warning">
                    Προσοχή: οι αιτήσεις που βρίσκονται σε κατάσταση{" "}
                    <b>«Επιστροφή στην Αιτούσα»</b> θα μεταβούν στην κατάσταση{" "}
                    <b>«Τέθηκε στο Αρχείο»</b>.
                </Alert>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="error" variant='contained'>
                    Άκυρο
                </Button>
                <Button
                    disabled={confirming}
                    variant="contained"
                    color="primary"
                    onClick={onUpdate}
                    startIcon={
                        confirming ? <CircularProgress size={16} color="inherit" /> : null
                    }
                >
                    {confirming ? "Ενημέρωση..." : "Επιβεβαίωση"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ArchiveConfirmDialog;
